"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setNamespaceCollisionFalse = setNamespaceCollisionFalse;
exports.userSettingsValidated = userSettingsValidated;
exports.resetEditSettingsConfig = resetEditSettingsConfig;
exports.updateDefaultLink = updateDefaultLink;
exports.updateNamespace = updateNamespace;
exports.setCalendarIntegrationChoice = setCalendarIntegrationChoice;
exports.setAuthedEmail = setAuthedEmail;
exports.updateCalendarIntegration = updateCalendarIntegration;
exports.updateExchangeInfo = updateExchangeInfo;
exports.updateCustomHostedDomainName = updateCustomHostedDomainName;
exports.fetchPrimaryCalendar = exports.FetchPrimaryCalendar = exports.FetchPrimaryCalendarActionTypes = exports.verifyCalendars = exports.VerifyCalendars = exports.VerifyCalendarsActionTypes = exports.fetchCustomHostedDomains = exports.FetchCustomHostedDomains = exports.FetchCustomHostedDomainsActionTypes = exports.fetchCalendarInfo = exports.FetchCalendarInfo = exports.FetchCalendarInfoActionTypes = exports.updateMeetingsUserIntegration = exports.UpdateMeetingsUserIntegration = exports.UpdateMeetingsUserIntegrationActionTypes = exports.fetchEmailProvider = exports.FetchEmailProvider = exports.FetchEmailProviderActionTypes = exports.disconnectMeetingsUser = exports.DisconnectMeetingsUser = exports.DisconnectMeetingsUserActionTypes = exports.validateNamespace = exports.ValidateNamespace = exports.ValidateNamespaceActionTypes = exports.updateMeetingsLink = exports.UpdateMeetingsLink = exports.UpdateMeetingsLinkActionTypes = exports.verifyUser = exports.VerifyUser = exports.VerifyUserActionTypes = exports.saveMeetingsUser = exports.SaveMeetingsUser = exports.SaveMeetingsUserActionTypes = exports.fetchLinks = exports.FetchLinks = exports.FetchLinksActionTypes = exports.createMeetingsUser = exports.CreateMeetingsUser = exports.CreateMeetingsUserActionTypes = exports.fetchMeetingsUser = exports.FetchMeetingsUser = exports.FetchMeetingsUserActionTypes = exports.MeetingsActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _fluxActions = require("flux-actions");

var _MeetingsUser = _interopRequireDefault(require("MeetingsBase/models/MeetingsUser"));

var _MeetingsLink = _interopRequireDefault(require("MeetingsBase/models/MeetingsLink"));

var _CustomHostedDomain = _interopRequireDefault(require("MeetingsBase/models/CustomHostedDomain"));

var _CalendarInfo = _interopRequireDefault(require("MeetingsBase/models/CalendarInfo"));

var _CalendarVerification = _interopRequireDefault(require("MeetingsBase/models/CalendarVerification"));

var MeetingsActionTypes = (0, _namespacedKeyMirror.default)({
  // Network actions
  FETCH_MEETINGS_USER: null,
  CREATE_MEETINGS_USER: null,
  FETCH_LINKS: null,
  SAVE_MEETINGS_USER: null,
  VERIFY_USER: null,
  UPDATE_MEETINGS_LINK: null,
  VALIDATE_NAMESPACE: null,
  DISCONNECT_MEETINGS_USER: null,
  FETCH_EMAIL_PROVIDER: null,
  UPDATE_MEETINGS_USER_INTEGRATION: null,
  FETCH_CALENDAR_INFO: null,
  FETCH_CUSTOM_HOSTED_DOMAINS: null,
  VERIFY_CALENDARS: null,
  FETCH_PRIMARY_CALENDAR: null,
  // MeetingsUser action
  SELECT_CALENDAR_INTEGRATION: null,
  SET_AUTHED_EMAIL: null,
  // Settings action
  SET_NAMESPACE_COLLISION_FALSE: null,
  USER_SETTINGS_VALIDATED: null,
  RESET_EDIT_SETTINGS_CONFIG: null,
  UPDATE_DEFAULT_LINK: null,
  UPDATE_NAMESPACE: null,
  UPDATE_CALENDAR_INTEGRATION: null,
  UPDATE_EXCHANGE_INFO: null,
  UPDATE_CUSTOM_HOSTED_DOMAIN_NAME: null
}, 'meetings');
exports.MeetingsActionTypes = MeetingsActionTypes;
var FetchMeetingsUserActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.FETCH_MEETINGS_USER);
exports.FetchMeetingsUserActionTypes = FetchMeetingsUserActionTypes;
var FetchMeetingsUser = (0, _actions.createRequestActions)(FetchMeetingsUserActionTypes, {
  successPayloadCreator: function successPayloadCreator(response) {
    return {
      data: _MeetingsUser.default.from(response)
    };
  }
});
exports.FetchMeetingsUser = FetchMeetingsUser;
var fetchMeetingsUser = (0, _fluxActions.createAction)(MeetingsActionTypes.FETCH_MEETINGS_USER);
exports.fetchMeetingsUser = fetchMeetingsUser;
var CreateMeetingsUserActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.CREATE_MEETINGS_USER);
exports.CreateMeetingsUserActionTypes = CreateMeetingsUserActionTypes;
var CreateMeetingsUser = (0, _actions.createRequestActions)(CreateMeetingsUserActionTypes, {
  successPayloadCreator: function successPayloadCreator(response, props) {
    return {
      data: _MeetingsUser.default.from(props)
    };
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateMeetingsUserActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('sales.meetings.notifications.integrationError')));
  }
});
exports.CreateMeetingsUser = CreateMeetingsUser;
var createMeetingsUser = (0, _fluxActions.createAction)(MeetingsActionTypes.CREATE_MEETINGS_USER, (0, _actions.mapPayloadTo)('data'));
exports.createMeetingsUser = createMeetingsUser;
var FetchLinksActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.FETCH_LINKS);
exports.FetchLinksActionTypes = FetchLinksActionTypes;
var FetchLinks = (0, _actions.createRequestActions)(FetchLinksActionTypes, {
  successPayloadCreator: function successPayloadCreator(response) {
    return {
      data: (0, _immutable.List)(response).map(function (ml) {
        return _MeetingsLink.default.from(ml);
      })
    };
  }
});
exports.FetchLinks = FetchLinks;
var fetchLinks = (0, _fluxActions.createAction)(MeetingsActionTypes.FETCH_LINKS);
exports.fetchLinks = fetchLinks;
var SaveMeetingsUserActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.SAVE_MEETINGS_USER);
exports.SaveMeetingsUserActionTypes = SaveMeetingsUserActionTypes;
var SaveMeetingsUser = (0, _actions.createRequestActions)(SaveMeetingsUserActionTypes, {
  successMetaCreator: function successMetaCreator(response, props) {
    var metadata = (0, _actions.createRequestStatusMeta)(SaveMeetingsUserActionTypes.base, _RequestStatusTypes.default.SUCCEEDED);

    if (props.stagedChangesCount > 0) {
      metadata = (0, _extends2.default)({}, metadata, (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('sales.meetings.notifications.saveSuccess')));
    }

    return metadata;
  },
  successPayloadCreator: function successPayloadCreator(response, props) {
    return {
      data: _MeetingsUser.default.from(response),
      props: props
    };
  },
  failureMetaCreator: function failureMetaCreator(response, props) {
    var metadata = (0, _actions.createRequestStatusMeta)(SaveMeetingsUserActionTypes.base, _RequestStatusTypes.default.FAILED);

    if (props.stagedChangesCount > 0) {
      metadata = (0, _extends2.default)({}, metadata, (0, _actions.createDangerNotificationMeta)(_I18n.default.text('sales.meetings.notifications.saveError')));
    }

    return metadata;
  }
});
exports.SaveMeetingsUser = SaveMeetingsUser;
var saveMeetingsUser = (0, _fluxActions.createAction)(MeetingsActionTypes.SAVE_MEETINGS_USER, (0, _actions.mapPayloadTo)('data'));
exports.saveMeetingsUser = saveMeetingsUser;
var VerifyUserActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.VERIFY_USER);
exports.VerifyUserActionTypes = VerifyUserActionTypes;
var VerifyUser = (0, _actions.createRequestActions)(VerifyUserActionTypes);
exports.VerifyUser = VerifyUser;
var verifyUser = (0, _fluxActions.createAction)(MeetingsActionTypes.VERIFY_USER);
exports.verifyUser = verifyUser;
var UpdateMeetingsLinkActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.UPDATE_MEETINGS_LINK);
exports.UpdateMeetingsLinkActionTypes = UpdateMeetingsLinkActionTypes;
var UpdateMeetingsLink = (0, _actions.createRequestActions)(UpdateMeetingsLinkActionTypes);
exports.UpdateMeetingsLink = UpdateMeetingsLink;
var updateMeetingsLink = (0, _fluxActions.createAction)(MeetingsActionTypes.UPDATE_MEETINGS_LINK, (0, _actions.mapPayloadTo)('data'));
exports.updateMeetingsLink = updateMeetingsLink;
var ValidateNamespaceActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.VALIDATE_NAMESPACE);
exports.ValidateNamespaceActionTypes = ValidateNamespaceActionTypes;
var ValidateNamespace = (0, _actions.createRequestActions)(ValidateNamespaceActionTypes);
exports.ValidateNamespace = ValidateNamespace;
var validateNamespace = (0, _fluxActions.createAction)(MeetingsActionTypes.VALIDATE_NAMESPACE, (0, _actions.mapPayloadTo)('data'));
exports.validateNamespace = validateNamespace;
var DisconnectMeetingsUserActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.DISCONNECT_MEETINGS_USER);
exports.DisconnectMeetingsUserActionTypes = DisconnectMeetingsUserActionTypes;
var DisconnectMeetingsUser = (0, _actions.createRequestActions)(DisconnectMeetingsUserActionTypes);
exports.DisconnectMeetingsUser = DisconnectMeetingsUser;
var disconnectMeetingsUser = (0, _fluxActions.createAction)(MeetingsActionTypes.DISCONNECT_MEETINGS_USER);
exports.disconnectMeetingsUser = disconnectMeetingsUser;
var FetchEmailProviderActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.FETCH_EMAIL_PROVIDER);
exports.FetchEmailProviderActionTypes = FetchEmailProviderActionTypes;
var FetchEmailProvider = (0, _actions.createRequestActions)(FetchEmailProviderActionTypes);
exports.FetchEmailProvider = FetchEmailProvider;
var fetchEmailProvider = (0, _fluxActions.createAction)(MeetingsActionTypes.FETCH_EMAIL_PROVIDER);
exports.fetchEmailProvider = fetchEmailProvider;
var UpdateMeetingsUserIntegrationActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.UPDATE_MEETINGS_USER_INTEGRATION);
exports.UpdateMeetingsUserIntegrationActionTypes = UpdateMeetingsUserIntegrationActionTypes;
var UpdateMeetingsUserIntegration = (0, _actions.createRequestActions)(UpdateMeetingsUserIntegrationActionTypes, {
  successPayloadCreator: function successPayloadCreator(response, props) {
    return {
      data: _MeetingsUser.default.from(response),
      props: props
    };
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateMeetingsUserActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('sales.meetings.notifications.integrationError')));
  }
});
exports.UpdateMeetingsUserIntegration = UpdateMeetingsUserIntegration;
var updateMeetingsUserIntegration = (0, _fluxActions.createAction)(MeetingsActionTypes.UPDATE_MEETINGS_USER_INTEGRATION, (0, _actions.mapPayloadTo)('data'));
exports.updateMeetingsUserIntegration = updateMeetingsUserIntegration;
var FetchCalendarInfoActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.FETCH_CALENDAR_INFO);
exports.FetchCalendarInfoActionTypes = FetchCalendarInfoActionTypes;
var FetchCalendarInfo = (0, _actions.createRequestActions)(FetchCalendarInfoActionTypes, {
  successPayloadCreator: function successPayloadCreator(response) {
    return {
      data: (0, _immutable.List)(response).map(function (calendarInfo) {
        return _CalendarInfo.default.from(calendarInfo);
      }).sortBy(function (calendarInfo) {
        return !calendarInfo.hasWriteAccess;
      })
    };
  }
});
exports.FetchCalendarInfo = FetchCalendarInfo;
var fetchCalendarInfo = (0, _fluxActions.createAction)(MeetingsActionTypes.FETCH_CALENDAR_INFO);
exports.fetchCalendarInfo = fetchCalendarInfo;
var FetchCustomHostedDomainsActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.FETCH_CUSTOM_HOSTED_DOMAINS);
exports.FetchCustomHostedDomainsActionTypes = FetchCustomHostedDomainsActionTypes;
var FetchCustomHostedDomains = (0, _actions.createRequestActions)(FetchCustomHostedDomainsActionTypes, {
  successPayloadCreator: function successPayloadCreator(response) {
    return {
      data: (0, _immutable.List)(response.objects).map(function (customHostedDomain) {
        return _CustomHostedDomain.default.from(customHostedDomain);
      })
    };
  }
});
exports.FetchCustomHostedDomains = FetchCustomHostedDomains;
var fetchCustomHostedDomains = (0, _fluxActions.createAction)(MeetingsActionTypes.FETCH_CUSTOM_HOSTED_DOMAINS);
exports.fetchCustomHostedDomains = fetchCustomHostedDomains;
var VerifyCalendarsActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.VERIFY_CALENDARS);
exports.VerifyCalendarsActionTypes = VerifyCalendarsActionTypes;
var VerifyCalendars = (0, _actions.createRequestActions)(VerifyCalendarsActionTypes, {
  successPayloadCreator: function successPayloadCreator(response) {
    return {
      data: (0, _immutable.Map)(response).map(function (value) {
        return _CalendarVerification.default.from(value);
      })
    };
  }
});
exports.VerifyCalendars = VerifyCalendars;
var verifyCalendars = (0, _fluxActions.createAction)(MeetingsActionTypes.VERIFY_CALENDARS);
exports.verifyCalendars = verifyCalendars;
var FetchPrimaryCalendarActionTypes = (0, _actions.createRequestTypes)(MeetingsActionTypes.FETCH_PRIMARY_CALENDAR);
exports.FetchPrimaryCalendarActionTypes = FetchPrimaryCalendarActionTypes;
var FetchPrimaryCalendar = (0, _actions.createRequestActions)(FetchPrimaryCalendarActionTypes, {
  successPayloadCreator: function successPayloadCreator(response) {
    return {
      data: (0, _immutable.Map)(response).map(function (value) {
        return _CalendarInfo.default.from(value);
      })
    };
  }
});
exports.FetchPrimaryCalendar = FetchPrimaryCalendar;
var fetchPrimaryCalendar = (0, _fluxActions.createAction)(MeetingsActionTypes.FETCH_PRIMARY_CALENDAR);
exports.fetchPrimaryCalendar = fetchPrimaryCalendar;

function setNamespaceCollisionFalse() {
  return {
    type: MeetingsActionTypes.SET_NAMESPACE_COLLISION_FALSE
  };
}

function userSettingsValidated() {
  return {
    type: MeetingsActionTypes.USER_SETTINGS_VALIDATED
  };
}

function resetEditSettingsConfig() {
  return {
    type: MeetingsActionTypes.RESET_EDIT_SETTINGS_CONFIG
  };
}

function updateDefaultLink(linkId) {
  return {
    type: MeetingsActionTypes.UPDATE_DEFAULT_LINK,
    linkId: linkId
  };
}

function updateNamespace(namespace) {
  return {
    type: MeetingsActionTypes.UPDATE_NAMESPACE,
    namespace: namespace
  };
}

function setCalendarIntegrationChoice(integrationChoice) {
  return {
    type: MeetingsActionTypes.SELECT_CALENDAR_INTEGRATION,
    integrationChoice: integrationChoice
  };
}

function setAuthedEmail(authedEmail) {
  return {
    type: MeetingsActionTypes.SET_AUTHED_EMAIL,
    authedEmail: authedEmail
  };
}

function updateCalendarIntegration(id, value) {
  return {
    type: MeetingsActionTypes.UPDATE_CALENDAR_INTEGRATION,
    id: id,
    value: value
  };
}

function updateExchangeInfo(info) {
  return {
    type: MeetingsActionTypes.UPDATE_EXCHANGE_INFO,
    info: info
  };
}

function updateCustomHostedDomainName(customHostedDomainName) {
  return {
    type: MeetingsActionTypes.UPDATE_CUSTOM_HOSTED_DOMAIN_NAME,
    customHostedDomainName: customHostedDomainName
  };
}